import { useNavigate } from "react-router-dom";
import "./not_found.css";
import { Helmet } from "react-helmet";

function WorkInProgress(params) {
    const navigator = useNavigate();
    return (
        <div className="not-found">
            <Helmet>
                <title>Work In Progress</title>
            </Helmet>
            <h1>Work in Progress</h1>
            <p className="zoom-area">The page you are looking for is <b>progress</b></p>

            <div className="link-container">
                <span onClick={() => { navigator("/dashboard"); }} style={{ cursor: "pointer" }} className="more-link">Home Page</span>
            </div>
        </div>
    );
}

export default WorkInProgress;